import {Person} from "../../../services/interface/query/person";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import NotPermissionComponent from "../NotPermissionComponent";
import {useFindChecklistCriminalRecord} from "../../../services/apis/apiChecklist";
import * as IconsMui from "@mui/icons-material";

interface Props {
    person?: Person;
}

/**
 * Verifica si la persona registra antecedentes penales.
 * Consume el endpoint POST /control_lists/criminal_record.
 *
 * @author cfernandez
 * @version 1.0.0
 * @since 2026-04-08
 */
export default function ChecklistCriminalRecord({person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findCriminalRecord,
        data: successCriminalRecord,
        error: errorCriminalRecord,
        isPending: loadingCriminalRecord,
    } = useFindChecklistCriminalRecord()

    const [response, setResponse] = useState<boolean | null | undefined>()

    useEffect(() => {
        if (person?.identification) {
            setResponse(undefined)
            findCriminalRecord({identifier: person.identification, msj: t('criminal-record')})
        }
    }, [person]);

    useEffect(() => {
        if (successCriminalRecord !== undefined) {
            setResponse(successCriminalRecord);
        }
    }, [successCriminalRecord]);

    const isResolved = response !== undefined && response !== null;

    return (
        <NotPermissionComponent
            className={'min-h-[50px]'}
            title={'/pn_checklist'}
            loading={loadingCriminalRecord}
            error={errorCriminalRecord}
            component={
                <div>
                    <div className={'flex flex-row gap-3 !border border-transparent border-b-secondary pb-3'}>
                        {isResolved ?
                            !response ?
                                <IconsMui.EmojiEmotionsTwoTone className={'text-success'}/> :
                                <IconsMui.SentimentDissatisfiedTwoTone className={'text-danger'}/> :
                            <IconsMui.NotificationsOffTwoTone className={'text-empColorSecondary'}/>
                        }
                        {t('criminal-record')}
                        <div className={'ml-auto flex flex-row gap-3 items-center'}>
                            {isResolved && response &&
                                <div className={'text-[9px] font-light text-danger'}>{t('criminal-record')}</div>}
                        </div>
                    </div>
                </div>
            }
        />
    )
}
